import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

interface Props {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  count?: number;
}

export const CollapsibleSection: React.FC<Props> = ({ title, children, defaultExpanded = true, count }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="mb-6">
      <button 
        type="button"
        className="flex items-center gap-2 font-semibold text-neutral-medium mb-3 hover:text-neutral-light transition-colors group"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <ChevronRight size={18} className={`transition-transform duration-200 text-neutral-medium group-hover:text-neutral-light ${isExpanded ? 'rotate-90' : ''}`} />
        <span className="text-base">{title}</span>
        {count !== undefined && (
          <span className="bg-primary-subtle text-neutral-medium px-2 py-0.5 rounded text-xs font-medium ml-1">
            {count}
          </span>
        )}
      </button>
      
      {isExpanded && (
        <div className="animate-in fade-in slide-in-from-top-1 duration-200">
          {children}
        </div>
      )}
    </div>
  );
};
